import { render } from "./ManagerImport.vue?vue&type=template&id=58ec9598"
import script from "./ManagerImport.vue?vue&type=script&lang=js"
export * from "./ManagerImport.vue?vue&type=script&lang=js"

import exportComponent from "/home/nodeapps/uzb/frontendBuild/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__